import React, { FC } from 'react';
import { useShowContext } from 'framework/show';
import { Alert } from 'framework/ui/mui-builder';
import { BillingType, useProjectDataContext } from 'domain/shared/newProject';
import MilestoneBillingList from './MilestoneBillingList';
import PeriodicPrepaidBillingList from './PeriodicPrepaidBillingList';
import PeriodicPostpaidBillingList from './PeriodicPostpaidBillingList';

type BillingListComponent = React.ComponentType<{ isSensitiveDataIsShown?: boolean }>;

type BillingListRegistry = Record<BillingType, BillingListComponent>;

const billingListRegistry: BillingListRegistry = {
  MILESTONE: MilestoneBillingList,
  PERIODIC_PREPAID: PeriodicPrepaidBillingList,
  PERIODIC_POSTPAID: PeriodicPostpaidBillingList,
};

interface BillingListFactoryProps {
  isSensitiveDataIsShown?: boolean;
}

const BillingListFactory: FC<BillingListFactoryProps> = ({ isSensitiveDataIsShown }) => {
  const { data } = useShowContext();
  const { data: projectData } = useProjectDataContext();
  const hasSowId = !!projectData?.accountData?.sowId;
  const billingType = data.result?.[0]?.billingType as BillingType;

  const BillingListComponent = billingListRegistry[billingType];

  if (!BillingListComponent) {
    const message = !hasSowId
      ? 'Billing schedule will be set up after the SOW has been signed by both parties'
      : 'No records found';
    return <Alert color="info">{message}</Alert>;
  }

  return <BillingListComponent isSensitiveDataIsShown={isSensitiveDataIsShown} />;
};

export default BillingListFactory;
